import { useState } from "react";
import { HiArrowsPointingIn, HiArrowsPointingOut } from "react-icons/hi2";
import { Modal } from "../layout/Modal";
import { ModalItemWithHeader } from "../layout/ModalItemWithHeader";
import {
	PDFViewer,
	type PDFViewerControl,
	STANDARD_EMBED_CLASS_NAME,
} from "../patterns/pdf-viewer";
import { trackingAttrs } from "../utils";

type PDFViewerModalProps = {
	control: PDFViewerControl | undefined;
	header?: string;
	onClose: () => void;
	/** Names the surface, e.g. `account-documents-attachment-viewer`; the viewer's controls build on it. */
	trackingId: string;
};

export const PDFViewerModal = ({ control, header, onClose, trackingId }: PDFViewerModalProps) => {
	const [isFullscreen, setIsFullscreen] = useState(false);

	const toggleFullscreen = () => {
		setIsFullscreen(!isFullscreen);
	};

	return (
		<>
			{control !== undefined && (
				<Modal onClickOutside={onClose}>
					<ModalItemWithHeader
						header={header}
						onClose={onClose}
						className={isFullscreen ? "!m-[10px]" : "!m-[20px]"}
						headerActions={
							<button
								onClick={toggleFullscreen}
								{...trackingAttrs(`${trackingId}-fullscreen`)}
								className="text-[18px] text-secondary hover:text-gray-800 cursor-pointer stroke-[2.25] mt-[1px] mr-2"
							>
								{isFullscreen ? <HiArrowsPointingIn /> : <HiArrowsPointingOut />}
							</button>
						}
					>
						<PDFViewer
							control={control}
							className={isFullscreen ? "h-[93vh] w-[98vw]" : STANDARD_EMBED_CLASS_NAME}
							trackingId={trackingId}
						/>
					</ModalItemWithHeader>
				</Modal>
			)}
		</>
	);
};
